import { useCallback, useEffect, useState } from 'react';
import { Tabs, Tab, Modal, ModalContent, ModalHeader, ModalBody, useDisclosure, Link } from "@nextui-org/react"; 
import { default as PersonalDetails2027 } from '../components/member-enrollment/2027/personal';
import { default as HealthDetails2027 } from '../components/member-enrollment/2027/health';
import { default as PremiumDetails2027 } from '../components/member-enrollment/2027/premium';
import { default as SignatureDetails2027 } from '../components/member-enrollment/2027/signature';
import { default as EndCover2027 } from '../components/member-enrollment/2027/end-cover';
import { default as PersonalDetails2026 } from '../components/member-enrollment/2026/personal';
import { default as HealthDetails2026 } from '../components/member-enrollment/2026/health';
import { default as PremiumDetails2026 } from '../components/member-enrollment/2026/premium';
import { default as SignatureDetails2026 } from '../components/member-enrollment/2026/signature';
import { default as EndCover2026 } from '../components/member-enrollment/2026/end-cover';
import { default as PersonalDetails2025 } from '../components/member-enrollment/2025/personal';
import { default as HealthDetails2025 } from '../components/member-enrollment/2025/health';
import { default as PremiumDetails2025 } from '../components/member-enrollment/2025/premium';
import { default as SignatureDetails2025 } from '../components/member-enrollment/2025/signature';
import { default as EndCover2025 } from '../components/member-enrollment/2025/end-cover';
import { cn, generateLinkToWebsite, getPlan } from '../lib/utils';
import PersonalTabIconSrc from '../assets/images/personal-tab-icon.svg';
import HealthTabIconSrc from '../assets/images/health-tab-icon.svg';
import PremiumTabIconSrc from '../assets/images/premium-tab-icon.svg';
import SignatureTabIconSrc from '../assets/images/signature-tab-icon.svg';
import Text from '../components/ui/text';

function App() {
  const [data, setData] = useState({});
  const [selectedTab, setSelectedTab] = useState("personal");
  const {isOpen, onOpen, onOpenChange} = useDisclosure();

  const updateData = useCallback((newData) => {
    setData({ ...data, ...newData});
  }, [data]);

  const goToTab = (tab) => setSelectedTab(tab);

  useEffect(() => {
    const plan = getPlan();
    if (plan) {
      updateData({
        planId: plan.id,
        planName: plan.name,
        planYear: plan.year,
      });
    } else {
      onOpen();
    }
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [selectedTab]);

  const stepProps = {
    data,
    goToTab,
    updateData
  }
  
  return (
    <>
      <div className='component-container font-monserrat w-full h-auto flex flex-col justify-start items-start font-normal'>
        <div className='w-full h-auto'>
          <div className="flex flex-col w-full">
            <Tabs 
              aria-label="Personal Details Sections" 
              variant='underlined'
              selectedKey={selectedTab}
              onSelectionChange={() => {}}
              classNames={{
                tabList: "gap-0 w-full relative rounded-none",
                cursor: "w-full bg-primary",
                tab: "font-monserrat mx-0 data-[focus=true]:outline-0 data-[selected=true]:outline-0 outline-0 flex-1 px-0 h-12 justify-start bg-white text-base hover:border-0 hover:border-b hover:cursor-default border-0 border-b hover:border-gray-600 border-gray-600",
                tabContent: "w-full font-bold tracking-[.2em] text-center opacity-50 hover:text-gray-500 group-data-[selected=true]:outline-0 group-data-[selected=true]:opacity-100 group-data-[selected=true]:text-gray-500 pl-2"
              }}
            >
              <Tab
                key="personal"
                title={
                  <div className="w-full flex flex-row justify-start items-center space-x-2 uppercase">
                    <img src={PersonalTabIconSrc} className='w-6 h-auto' />
                    <div className='flex-1 w-full'>
                      <Text className='text-gray-700'>Personal</Text>
                    </div>
                  </div>
                }
              />
              <Tab
                key="health"
                title={
                  <div className="w-full flex flex-row justify-start items-center space-x-2 uppercase">
                    <img src={HealthTabIconSrc} className='w-6 h-auto' />
                    <div className='flex-1 w-full'><Text className='text-gray-700'>Health</Text></div>            
                  </div>
                }
              />
              <Tab
                key="premium"
                title={
                  <div className="w-full flex flex-row justify-start items-center space-x-2 uppercase">
                    <img src={PremiumTabIconSrc} className='w-6 h-auto' />
                    <div className='flex-1 w-full'><Text className='text-gray-700'>Premium</Text></div>          
                  </div>
                }
              />
              <Tab
                key="signature"
                title={
                  <div className="w-full flex flex-row justify-start items-center space-x-2 uppercase">
                    <img src={SignatureTabIconSrc} className='w-6 h-auto' />
                    <div className='flex-1 w-full'><Text className='text-gray-700'>Signature</Text></div>     
                  </div>
                }
              />
            </Tabs>
          </div>
          <div className='mt-5'>
            <div className={cn(selectedTab !== 'personal' ? 'hidden' : 'block')}>
              {data?.planYear === '2027' ? <PersonalDetails2027 {...stepProps} /> : data?.planYear === '2026' ? <PersonalDetails2026 {...stepProps} /> : <PersonalDetails2025 {...stepProps} />}
            </div>
            <div className={cn(selectedTab !== 'health' ? 'hidden' : 'block')}>
              {data?.planYear === '2027' ? <HealthDetails2027 {...stepProps} /> : data?.planYear === '2026' ? <HealthDetails2026 {...stepProps} /> : <HealthDetails2025 {...stepProps} />}
            </div>
            <div className={cn(selectedTab !== 'premium' ? 'hidden' : 'block')}>
              {data?.planYear === '2027' ? <PremiumDetails2027 {...stepProps} /> : data?.planYear === '2026' ? <PremiumDetails2026 {...stepProps} /> : <PremiumDetails2025 {...stepProps} />}
            </div>
            <div className={cn(selectedTab !== 'signature' ? 'hidden' : 'block')}>
              {data?.planYear === '2027' ? <SignatureDetails2027 {...stepProps} /> : data?.planYear === '2026' ? <SignatureDetails2026 {...stepProps} /> : <SignatureDetails2025 {...stepProps} />}
            </div>
            <div className={cn(selectedTab !== 'end-cover' ? 'hidden' : 'block')}>
              {data?.planYear === '2027' ? <EndCover2027 {...stepProps} /> : data?.planYear === '2026' ? <EndCover2026 {...stepProps} /> : <EndCover2025 {...stepProps} />}
            </div>
          </div>  
        </div>
        <Modal className='twp' isOpen={isOpen} onOpenChange={onOpenChange} isDismissable={false} isKeyboardDismissDisabled={false} hideCloseButton={true}>
          <ModalContent>
          {(onClose) => (
              <>
                  <ModalHeader className="flex flex-col gap-1"><Text>Select A Plan</Text></ModalHeader>
                  <ModalBody className='p-3 flex flex-row justify-center'>
                    <Link isBlock showAnchorIcon href={generateLinkToWebsite('/our-plans')} color="primary">
                      <Text>See available plans</Text>
                    </Link>
                  </ModalBody>
              </>
          )}
          </ModalContent>
        </Modal>
      </div>

    </>
  )
}

export default App;
